import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Global routes
export const globalIntegrationsRoute: InvariantJiraRoute = {
	name: 'eoc-integrations',
	path: '/jira/settings/products/ops/integrations',
	exact: true,
};
